import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiMagnify, mdiSettings } from '@lumapps/lumx/icons';
import { coveoSearchSettings } from '@lumapps/search-coveo-backoffice/routes';
import { useTranslate } from '@lumapps/translations';

import { SEARCH_SETTINGS } from '../../keys';
import { searchSettings } from '../../routes';

export type SearchSettingsSideNavigationProps = Partial<SideNavigationItemProps> & {
    id: string;
    isOpen?: boolean;
    canAdminCoveo: boolean;
    canAdminNS: boolean;
};

export const SearchSettingsSideNavigation: React.FC<SearchSettingsSideNavigationProps> = ({
    id,
    isOpen = false,
    canAdminCoveo,
    canAdminNS,
    ...restOfProps
}) => {
    const { translateKey } = useTranslate();

    // Coveo does not need to have Admin NS entry
    if (canAdminCoveo) {
        return (
            <SideNavigationItem
                {...restOfProps}
                route={coveoSearchSettings()}
                label={translateKey(SEARCH_SETTINGS.TITLE)}
                icon={mdiMagnify}
                id={`${id}--coveo`}
            />
        );
    }

    if (canAdminNS) {
        return (
            <SideNavigationItem
                {...restOfProps}
                label={translateKey(SEARCH_SETTINGS.TITLE)}
                icon={mdiSettings}
                id={id}
                isOpen={isOpen}
            >
                <SideNavigationItem
                    route={searchSettings()}
                    label={translateKey(SEARCH_SETTINGS.RESULTS_SETTINGS)}
                    id={`${id}--ns`}
                />
            </SideNavigationItem>
        );
    }

    return null;
};
